// Deterministic helpers for the audio code (no Math.random anywhere in audio/: recipe takes, pitch jitter and
// variant picks are seeded so unit tests, the WAV bake and a Unity port reproduce them).

/** mulberry32: uniform [0, 1) from a 32-bit seed. */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** FNV-1a (32-bit) of a string: stable per-sound seeds ("merge.default#2"). */
export function hashString(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h;
}

/** FNV-1a (32-bit) over the raw bytes of a sample buffer (determinism checks). */
export function hashSamples(xs: Float32Array): number {
  let h = 0x811c9dc5;
  const bytes = new Uint8Array(xs.buffer, xs.byteOffset, xs.byteLength);
  for (const b of bytes) {
    h ^= b;
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h;
}
